export const apiUrl = "https://senlermedia-backend.herokuapp.com";
// export const apiUrl = "https://ff31-124-29-228-217.jp.ngrok.io";

export const socketURL = `${apiUrl}`;

export const stripe_public_key = `pk_test_51L8FqNL51LXb45sopLMv0wOiEZvg9NhshZWh0vWC7Okl7Alm2n01MGG89jdvovL41Fw98xNs1I0VqIn29KCD9JQc00acfYgJBk`;

export const imageUrl = (url) => `${apiUrl}/api/images/${url}`;

export const BaseURL = (link) => {
  return `${apiUrl}/api/v1/${link}`;
};

export const endpointsUrl = (role) => {
  const roleFound = role == "admin" ? "admin" : "sub-admin";
  return roleFound;
};

// export const base64ToImage = (img) => {
//   var image = new Image();
//   image.src = img;
//   document.body.appendChild(image);
//   return image;
// };

export function base64ToImage(imageBuffer, setter) {
  const url = imageBuffer;
  fetch(url)
    .then((res) => res.blob())
    .then((blob) => {
      const file = new File([blob], "File name", { type: "image/jpeg" });
      setter(file);
    });
}

export function capture(setThumbnailPicture) {
  var canvas = document.getElementById("canvas");
  let video = document.getElementById("video");

  const test = canvas.getContext("2d").drawImage(video, 0, 0, 250, 400);
  // test.scale(3, 3);
  const dataUrl = canvas.toDataURL();

  const immm = `data:image/jpeg;base64,${dataUrl}`;

  var image = new Image();
  image.onload = function () {
    test.drawImage(image, 0, 0, 250, 400);
  };
  image.src = immm;
  let imageBuffer = canvas.toDataURL();
  setThumbnailPicture(null);
  base64ToImage(imageBuffer, setThumbnailPicture);
}

export const onClickHandler = (event, setThumbnailPicture) => {
  const file = event.target.files[0];

  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onloadend = () => {
    const base64String = reader.result.split(",")[1];

    var canvas = document.getElementById("canvas");
    // For Clear Image in Canvas ---
    const context = canvas.getContext("2d");
    context.clearRect(0, 0, canvas.width, canvas.height);
    // For Clear Image in Canvas ---

    var ctx = canvas.getContext("2d");
    const immm = `data:image/jpeg;base64,${base64String}`;

    var image = new Image();
    image.onload = function () {
      ctx.drawImage(image, 0, 0, 250, 400);
    };
    image.src = immm;
    let imageBuffer = canvas.toDataURL();
    base64ToImage(imageBuffer, setThumbnailPicture);
  };
};

export const apiHeader = (token, isFormData) => {
  if (token && !isFormData) {
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
  }
  if (token && isFormData) {
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    };
  }
  if (!token && !isFormData) {
    return {
      headers: {
        "Content-Type": "application/json",
      },
    };
  }

  if (!token && isFormData) {
    return {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
  }
};

export const validateEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const capitalizeFirstLetter = (l) =>
  l.charAt(0).toUpperCase() + l.slice(1);

export const CreateFormData = (data) => {
  const formData = new FormData();
  for (let key in data) {
    formData.append(key, data[key]);
  }
  return formData;
};

export const firebaseVapidObject = {
  vapidKey:
    "BKlmZ2T6iSDR1mOAaQOzBEbwHdlYX71OqZOwvvja_oDliCf9eRrb8Rgo_dasRs9WCpgSppH0O0kvtIOc959bO0U",
};

export function dataURLToFile(dataurl, filename = `${Math.random()}.jpeg`) {
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}

export const formRegEx = /([a-z])([A-Z])/g;
export const formRegExReplacer = "$1 $2";

export var recordsLimit = 10;

export function convertPNGtoJPEG(pngBlob) {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const img = new Image();

    img.onload = function () {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);

      canvas.toBlob(
        function (jpegBlob) {
          resolve(jpegBlob);
        },
        "image/jpeg",
        1
      );
    };
    img.onerror = reject;
    img.src = URL.createObjectURL(pngBlob);
  });
}
